export default __webpack_public_path__ + "static/media/jehrodriguesmakeup.4ae50e3e.jpg";